<script setup lang="ts">
import { AppBadge, BadgeCustomerBrand } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'
import { WrapperGeneralInfo } from '@shared/ui/wrappers'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useSectionKidGeneral } from '../model/section-kid-general.hook'
import KidActions from './KidActions.vue'
import KidGeneralInfo from './KidGeneralInfo.vue'
import KidOtherInfo from './KidOtherInfo.vue'
import KidBalanceInfo from './KidBalanceInfo.vue'
import KidNotesInfo from './KidNotesInfo.vue'

defineOptions({
  name: 'SectionKidGeneral',
})

const {
  refTitle,
  refBrand,
  isCustomerGo,
  hasKid,
  isProcessing,
  canViewKids,
  canManageKids,
  canDeleteKids,
  save,
} = useSectionKidGeneral()
</script>

<template>
  <CardAdmin
    flexible
    fullwidth
    class="section-kid-general"
  >
    <template #title>
      <div class="section-kid-general__title">
        <AppText name="h3">
          {{ refTitle }}
        </AppText>
        <AppBadge
          v-if="isCustomerGo"
          color="emerald"
          text="Goal"
        />
        <BadgeCustomerBrand
          :brand="refBrand"
          view="icon"
        />
      </div>
    </template>
    <template #header>
      <div
        v-if="canViewKids"
        class="section-kid-general__controls"
      >
        <KidActions v-if="canDeleteKids" />
        <BtnPrimary
          v-if="canManageKids"
          text="Save"
          color="emerald"
          :disabled="isProcessing"
          @click="save"
        />
      </div>
    </template>
    <WrapperGeneralInfo v-if="hasKid">
      <template #info>
        <KidGeneralInfo />
        <KidOtherInfo />
      </template>
      <template #additional>
        <KidBalanceInfo />
        <KidNotesInfo />
      </template>
    </WrapperGeneralInfo>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./SectionKidGeneral.scss" />
